'use client';

import { JobDeliverableSelectField } from './JobDeliverableSelectField';
import styles from './JobDeliverableSelectFields.module.scss';
import { JobSelectField } from './JobSelectField';

type JobDeliverableSelectionValue = {
  jobId: string;
  deliverableId: string;
};

type JobDeliverableSelectFieldsProps = {
  value: JobDeliverableSelectionValue;
  onChange: (value: JobDeliverableSelectionValue) => void;
  jobError?: string;
  deliverableError?: string;
  disabled?: boolean;
  jobLabel?: string;
  deliverableLabel?: string;
  jobName?: string;
  deliverableName?: string;
  layout?: 'horizontal' | 'vertical';
};

export function JobDeliverableSelectFields({
  value,
  onChange,
  jobError,
  deliverableError,
  disabled = false,
  jobLabel = 'Job',
  deliverableLabel = 'Deliverable',
  jobName = 'job-select',
  deliverableName = 'deliverable-select',
  layout = 'horizontal',
}: JobDeliverableSelectFieldsProps) {
  const handleJobChange = (nextJobId: string) => {
    const nextDeliverableId =
      nextJobId === value.jobId ? value.deliverableId : '';

    onChange({
      jobId: nextJobId,
      deliverableId: nextDeliverableId,
    });
  };

  const handleDeliverableChange = (nextDeliverableId: string) => {
    onChange({
      jobId: value.jobId,
      deliverableId: nextDeliverableId,
    });
  };

  const layoutClass =
    layout === 'vertical'
      ? styles['jobDeliverableSelectFields--vertical']
      : styles['jobDeliverableSelectFields--horizontal'];

  return (
    <div className={`${styles.jobDeliverableSelectFields} ${layoutClass}`}>
      <JobSelectField
        name={jobName}
        label={jobLabel}
        value={value.jobId}
        error={jobError}
        disabled={disabled}
        onChange={handleJobChange}
      />
      <JobDeliverableSelectField
        name={deliverableName}
        label={deliverableLabel}
        jobId={value.jobId}
        value={value.deliverableId}
        error={deliverableError}
        disabled={disabled || !value.jobId}
        onChange={handleDeliverableChange}
      />
    </div>
  );
}

export type { JobDeliverableSelectionValue };
